import Screen from '@/styles/Themes/Screen';
import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';

export const TableContainer = styled.div<{ isDesktop?: boolean }>`
    background-color: ${cssVars.bg_ash_dark3};
    border: 1px solid ${cssVars.bg_gray4_dark2};
    border-radius: 16px;
    margin: 20px 0;
    padding: 30px 30px 16px;
    display: ${({ isDesktop }) => (!isDesktop ? 'block' : 'none')};
    height: fit-content;

    ${Screen.desktop} {
        display: ${({ isDesktop }) => (isDesktop ? 'block' : 'none')};
    }

    > :last-child {
        border: none;
        padding-bottom: 0;
    }
`;

export const StarIcon = styled.div`
    flex: none;
`;

export const TableTitle = styled.div`
    ${Text.Full.heading4}
    color: ${Palette.green.normal};
`;

export const TableBlock = styled.ul`
    border-bottom: 1px solid ${Palette.green.normal};
    padding-bottom: 20px;
    padding-left: 0;
`;

export const ItemsBlock = styled.ul`
    padding-left: 24px;
`;

export const MainItem = styled.li`
    ${Text.Full.large.semibold}
    color: ${cssVars.fg_gray1_white};
    list-style: none;

    > :first-child {
        display: flex;
        cursor: pointer;

        :hover {
            text-decoration: underline;
        }

        > svg {
            height: 16px;
            width: 16px;
            margin-right: 8px;
            flex-shrink: 1;
            flex: none;

            > path {
                fill: ${Palette.green.normal};
            }
        }
    }
`;

export const Item = styled.li`
    ${Text.Full.medium.medium}
    color: ${cssVars.fg_gray2_gray3};
    list-style: none;
    margin-top: 8px;
`;
